<template>
  <div class="device-params-tech">
    <section
      v-for="(section, sIndex) in sections"
      :key="section.title"
      class="device-params-tech__section"
    >
      <header class="device-params-tech__section-head">
        <span class="device-params-tech__index">{{
          String(sIndex + 1).padStart(2, '0')
        }}</span>
        <h3 class="device-params-tech__section-title">{{ section.title }}</h3>
      </header>

      <div
        v-for="(block, bIndex) in section.blocks"
        :key="section.title + '-' + bIndex"
        class="device-params-tech__block"
      >
        <h4 v-if="block.title" class="device-params-tech__block-title">
          {{ block.title }}
        </h4>
        <p v-if="block.note" class="device-params-tech__note">{{ block.note }}</p>
        <ul class="device-params-tech__list">
          <li
            v-for="(item, iIndex) in block.items"
            :key="section.title + '-' + bIndex + '-' + iIndex"
            class="device-params-tech__item"
          >
            <span class="device-params-tech__label">{{ item.label }}</span>
            <span class="device-params-tech__value">{{ item.value }}</span>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { getDeviceParamsSections } from './deviceParams.js'

export default {
  name: 'DeviceParamsPanel',
  props: {
    lang: {
      type: String,
      default: 'zh'
    }
  },
  computed: {
    sections() {
      return getDeviceParamsSections(this.lang)
    }
  }
}
</script>

<style scoped>
.device-params-tech {
  color: rgba(255, 255, 255, 0.92);
  padding-right: 4px;
}

.device-params-tech__section {
  position: relative;
  flex-shrink: 0;
  margin-bottom: 14px;
  padding: 14px 16px 12px;
  border: 1px solid rgba(0, 255, 255, 0.28);
  border-radius: 10px;
  background: linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.08),
      transparent 42%
    ),
    rgba(0, 40, 80, 0.42);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 0 18px rgba(0, 255, 255, 0.08);
  overflow: visible;
}

.device-params-tech__section:last-child {
  margin-bottom: 0;
}

.device-params-tech__section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 255, 255, 0.95),
    transparent
  );
}

.device-params-tech__section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 255, 255, 0.15);
}

.device-params-tech__index {
  flex-shrink: 0;
  min-width: 36px;
  height: 22px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #02101c;
  background: #00ffff;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.45);
}

.device-params-tech__section-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #00ffff;
  letter-spacing: 0.02em;
}

.device-params-tech__block + .device-params-tech__block {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed rgba(0, 255, 255, 0.15);
}

.device-params-tech__block-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}

.device-params-tech__note {
  margin: 0 0 8px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.68);
  background: rgba(0, 255, 255, 0.08);
  border-left: 2px solid #00ffff;
  border-radius: 0 6px 6px 0;
}

.device-params-tech__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.device-params-tech__item {
  display: table;
  width: 100%;
  table-layout: fixed;
  margin-bottom: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(0, 30, 60, 0.62);
  border: 1px solid transparent;
  box-sizing: border-box;
}

.device-params-tech__item:last-child {
  margin-bottom: 0;
}

.device-params-tech__item:hover {
  border-color: rgba(0, 255, 255, 0.28);
}

.device-params-tech__label {
  display: table-cell;
  width: 180px;
  vertical-align: top;
  padding-right: 16px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.62);
}

.device-params-tech__value {
  display: table-cell;
  vertical-align: top;
  font-size: 13px;
  line-height: 1.55;
  color: #00e5ff;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  word-break: break-word;
}
</style>
